export class SignalRConstants {
    public static NotificationEventResult = "NotificationEventResult";
}
